<template>
    <div id="app">
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    // 这里可以添加一些应用级别的逻辑或者数据
  };
  </script>
  
  <style>
  /* 添加一些全局样式 */
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* border: 10px solid yellow; */
  }

  </style>
  